module.exports = __webpack_public_path__ + "img/093-basque-country.2cd5b594.svg";